import { ChainId } from '@blast/v2-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.BLAST_SEPOLIA]: '0x68516D2b7bE78D919d0f46f2adc65f5Cd7F9E3f7',
  [ChainId.BLAST_MAINNET]: '0x4030e5bdCa3f80cDd19400488e3B5b8461DF581D'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
